"use client";

import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const cities = [{
  id: 1,
  name: "Arlington"
}, {
  id: 2,
  name: "Fairfax"
}, {
  id: 3,
  name: "Alexandria"
}, {
  id: 4,
  name: "Reston"
}, {
  id: 5,
  name: "Vienna"
}, {
  id: 6,
  name: "Falls Church"
}, {
  id: 7,
  name: "McLean"
}, {
  id: 8,
  name: "Tysons"
}, {
  id: 9,
  name: "Herndon"
}, {
  id: 10,
  name: "Ashburn"
}, {
  id: 11,
  name: "Pennsylvania"
}, {
  id: 12,
  name: "DC"
}, {
  id: 13,
  name: "Maryland"
}, {
  id: 14,
  name: "West Virginia"
}];
export default function ServiceAreas() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="py-16 bg-background">
      <div className="container mx-auto px-4">
        <h2 ref={ref} className={`text-3xl md:text-4xl font-display font-bold text-center mb-12 text-foreground transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          Service Areas
        </h2>

        <div className={`flex flex-wrap justify-center items-center gap-4 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {cities.map((city, i) => <Badge key={city.id} data-index={i} variant="outline" className="px-6 py-2.5 text-sm font-semibold rounded-full border-2 border-primary text-foreground bg-background hover:bg-primary-light hover:border-primary-hover hover:-translate-y-1 hover:shadow-md transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] cursor-pointer">
              {city.name}
            </Badge>)}
        </div>
      </div>
    </section>;
}